import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { Part } from 'src/app/interface/part';

@Component({
  selector: 'app-average-purchase-cost-alert',
  standalone: true,
  imports: [
    CommonModule,

    MatDialogTitle,
    MatDialogContent,
    MatTableModule,
    MatIcon,
    MatDialogActions,
    MatButtonModule,
    MatDialogClose
  ],
  templateUrl: './average-purchase-cost-alert.component.html',
  styleUrl: './average-purchase-cost-alert.component.scss'
})
export class AveragePurchaseCostAlertComponent {

  parts: Array<{
    part: Part;
    liquidValue: number;
  }>;
  isMobile: boolean;

  columns = ['code', 'description']
  constructor (
    @Inject(MAT_DIALOG_DATA) private data: {
      parts: Array<{
        part: Part;
        liquidValue: number;
      }>,
      isMobile: boolean;
    },
  ) {
    if (data) {
      this.parts = data.parts;
      this.isMobile = data.isMobile;
    }
  }

}
